import { createSelector } from 'reselect';

import { AppState } from 'shared/store/app/types';

export const app = (state: { app: AppState }): AppState => state.app;

export const onIntlNetwork = createSelector([app], (appData): boolean => appData.onIntlNetwork);
